<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import VirtualComponents from 'src/components/DevicesSettings/VirtualComponents/VirtualComponents.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
</script>

<SidepanelContent>
	<VirtualComponents {device} />
</SidepanelContent>
